export default {
  "data": [{
    "stat": [
      {
        "name": "조회기간별 통계",
        "categories": [
          {
            "categoryName": "소식톡톡",
            "categories": [
              {
                "categoryName": "수신건수"
              },
              {
                "categoryName": "확인건수"
              }
            ]
          },
          {
            "categoryName": "두뇌톡톡",
            "categories": [
              {
                "categoryName": "요청건수"
              },
              {
                "categoryName": "완료건수"
              }
            ]
          },
          {
            "categoryName": "건강톡톡",
            "categories": [
              {
                "categoryName": "요청건수"
              }
            ]
          }
        ]
      },
      {
        "name": "누적 통계(죄회기간 무관)",
        "categories": [
          {
            "categoryName": "두뇌톡톡",
            "categories": [
              {
                "categoryName": "평균점수"
              },
              {
                "categoryName": "요청건수"
              },
              {
                "categoryName": "완료건수"
              },
              {
                "categoryName": "완료일수"
              }
            ]
          }
        ]
      }
    ]
  }]
}
